<template>
	<div :class="[{ 'open' : open }, 'service']" @click.stop="openService">
		<div class="product" v-if="!loading">
			<div class="title">
				<span class="name" :title="service.product.name">
					<div class="status">
						<div class="ui horizontal label small" v-if="service.status === 'unset' || service.status === 'deletable'">{{ $t('components.service.status.unset') }}</div>
						<div class="ui horizontal green label small" v-if="service.status === 'active'">{{ $t('components.service.status.active') }}</div>
						<div class="ui horizontal red label small" v-if="service.status === 'inactive'">{{ $t('components.service.status.inactive') }}</div>
						<div class="ui horizontal red label small" v-if="service.status === 'overdue'">{{ $t('components.service.status.overdue') }}</div>
					</div>
					<span>
						{{ shortString(service.product.name, 46) }}
					</span>
				</span>

				<div class="meta">
					<span class="next-date">
						{{ $t('components.service.payment_date') }} {{ formatDate(service.transaction_date) }}
					</span>
				</div>

				<div class="right">
					<button class="ui blue circular mini button" v-if="service.status === 'unset' || service.status === 'deletable'" @click.stop="openService">
						{{ $t('globals.buttons.finish') }}
					</button>
					<button class="ui circular mini button absolute-button" :class="{ 'blue' : service.status === 'active' }" @click.stop="openService">
						{{ open ? $t('globals.buttons.close') : $t('globals.buttons.open') }}
					</button>
          <button class="ui circular mini button" v-if="waitlistid && canChangePaymentMethod"
                  @click.prevent="updatePaymentModal = !updatePaymentModal">
            {{ $t('globals.buttons.change_card') }}
          </button>
					<button class="ui circular grey mini button"
							@click.prevent="cancelServiceModal = !cancelServiceModal"
							v-if="canBeCancelled">
						{{ $t('globals.buttons.cancel') }}
					</button>
				</div>
			</div>

			<div class="info">
				<span class="interval">
					<span class="metatitle">{{ $t('components.service.payment_type') }}</span>
					<span v-if="service.pricing">
						<i class="refresh icon" v-if="service.pricing.type === 'recurring'"/>
						<i class="money bill alternate icon" v-else-if="service.pricing.type === 'instant'"/>
						{{ interval }}
					</span>
					<span v-else>
						{{ $t('components.service.unset') }}
					</span>
				</span>

				<span class="payment">
					<span class="metatitle">{{ $t('components.service.payment_method') }}</span>
					<span v-if="cardDigits" v-html="getCardIcon"></span>
          <span v-else-if="service.payment_method === 'mobile_pay'">Mobile Pay</span>
          <span v-else-if="service.payment_method === 'vipps'">Vipps</span>
					<span v-else>
						{{ $t('components.service.unset') }}
					</span>
				</span>

				<span class="price">
					<span class="metatitle">{{ $t('components.service.price') }}</span>
					{{ formatPrice(service.pricing_amount) }}
				</span>
			</div>
		</div>

		<semantic-loading :active="loading" :text="$t('globals.loaders.loading')"></semantic-loading>

		<new-waitlist-modal :subscription="service" :active="showSubscriptionModal" @refreshsubscription="refreshService"></new-waitlist-modal>

		<modal ref="modal"
			:active="cancelServiceModal"
			:icons="'big payment'"
			:title="$t('globals.validation.warnings.are_you_sure')"
			:popout="true"
			@acceptmodal="cancelService()" @denymodal="declineCancelService()">
			<h4>{{ $t('components.service.validation.cancel_service') }}</h4>

			<div slot="box-actions">
				<div class="ui red basic circular button" @click="$refs.modal.denyModal()">{{ $t('globals.buttons.no') }}</div>
				<div class="ui blue circular button" @click="$refs.modal.acceptModal()">{{ $t('globals.buttons.yes') }}</div>
			</div>
		</modal>

    <modal ref="payment_update_modal"
           :active="updatePaymentModal"
           :icons="'big payment'"
           :title="$t('globals.validation.warnings.are_you_sure')"
           :popout="true"
           @acceptmodal="updatePaymentInformation()" @denymodal="closePaymentModal()">
      <h4>{{ $t('components.service.validation.update_payment_information') }}</h4>

      <div slot="box-actions">
        <div class="ui red basic circular button" @click="$refs.payment_update_modal.denyModal()">{{ $t('globals.buttons.no') }}</div>
        <div class="ui blue circular button" @click="$refs.payment_update_modal.acceptModal()">{{ $t('globals.buttons.yes') }}</div>
      </div>
    </modal>
	</div>
</template>

<script>
	import moment from 'moment'
	import accounting from 'accounting'
	import { truncate } from 'lodash'

	export default {
		name: 'Service',

		props: {
			subscriptionid: {
				required: false,
				default: null,
				type: Number
			},

			waitlistid: {
				required: false,
				default: null,
				type: Number
			},

			open: {
				required: false,
				default: false,
				type: Boolean
			}
		},

		data () {
			return {
				loading: true,
				service: null,
				showSubscriptionModal: false,
				cancelServiceModal: false,
        updatePaymentModal: false
			}
		},

		mounted () {
			this.initFetch()
			const _this = this

			this.$events.$on('refreshservice', (data) => {
				if (data.id === _this.service.id) {
					this.initFetch()
				}
			})
		},

		methods: {
			initFetch () {
				if (this.subscriptionid !== null && typeof this.subscriptionid === 'number') {
					this.fetchSubscription(this.subscriptionid)
						.then(Subscription => {
							this.service = Subscription

							this.$nextTick(() => {
								this.loading = false
							})
						})
				} else if (this.waitlistid !== null && typeof this.waitlistid === 'number') {
					this.fetchWaitList(this.waitlistid)
						.then(Waitlist => {
							this.service = Waitlist

							this.$nextTick(() => {
								this.loading = false
							})
						})
				}
			},

			openService () {
        if (!this.cancelServiceModal) {
          if (this.service.status === 'unset' || this.service.status === 'deletable') {
            this.showSubscriptionModal = !this.showSubscriptionModal
          } else {
            this.$emit('selectService', this.service)
          }
        }
			},

      updatePaymentInformation () {
        this.$refs.payment_update_modal.denyModal()
        this.$nextTick(() => {
          setTimeout(() => {
            this.$router.push({
              name: 'checkout',
              params: { containerId: this.service.id },
              query: {container: 'waitlist', subscriptionId: this.service.nets_details.subscription_id}
            })
          }, 500)
        })
      },

			fetchSubscription (subscriptionid) {
				return new Promise((resolve, reject) => {
					if (subscriptionid) {
						this.axios.get(`subscriptions/${subscriptionid}`)
							.then(({data}) => {
								// resolve the subscription
								resolve(data)
							}, error => {
								reject(error)
							})
					} else {
						reject('Missing Subscription ID')
					}
				})
			},

			fetchWaitList (waitlistid) {
				return new Promise((resolve, reject) => {
					if (waitlistid) {
						this.axios.get(`waitlistsubscriptions/${waitlistid}`)
							.then(({data}) => {
								resolve(data)
							}, error => {
								reject(error)
							})
					} else {
						reject('Missing Waitlist ID')
					}
				})
			},

			formatDate (string, format = 'Do MMM, YYYY') {
				return moment(string).format(format)
			},

			formatPrice (amount, minfrac = 2) {
				if (amount !== null) {
					var currency = null
					if (this.service.product && this.service.product.pricing[0].currency) {
						currency = this.service.product.pricing[0].currency
					}
					return accounting.format(amount, minfrac) + currency
				} else {
					return this.$t('components.service.no_price')
				}
			},

			refreshService (id) {
				const url = (this.service.product.waitlist === 1) ? `waitlistsubscriptions/${id}` : `subscriptions/${id}`
				this.axios.get(url)
					.then(({data}) => {
						this.service.product.fields = data.product.fields
						this.service.accessories = data.accessories
						this.service.pricing_plans = data.pricing_plans
					}).catch()
			},

			cancelService () {
				return new Promise((resolve, reject) => {
					const url = (this.waitlistid !== null && typeof this.waitlistid === 'number') ? `waitlistsubscriptions/${this.service.id}` : `subscriptions/${this.service.id}`

					this.axios.delete(url)
						.then(data => {
							this.$events.$emit('subscription-cancelled', data, true)

							this.$events.$emit('alert', {
								header: this.$t('globals.validation.success.success'),
								message: this.$t('components.service.validation.success.service_cancelled'),
								type: 'success',
								align: 'right'
							})
						}).catch((error) => {
              if (error.response.data.message) {
                this.$events.$emit('alert', {
                  header: this.$t('globals.validation.errors.error'),
                  message: error.response.data.message,
                  type: 'error',
                  align: 'right'
                })
              } else {
                this.$events.$emit('alert', {
                  header: this.$t('globals.validation.errors.something_went_wrong'),
                  message: this.$t('globals.validation.errors.try_again_later'),
                  type: 'error',
                  align: 'right'
                })
              }
						})
				})
			},

      declineCancelService () {
        this.cancelServiceModal = false
      },

      closePaymentModal () {
        this.updatePaymentModal = false
      },

			shortString (longString, length = 120) {
				return truncate(longString, {
					length
				})
			}
		},

		computed: {
			interval () {
				let interval = this.$t('components.service.unset')

				if (this.service.pricing !== null && this.service.pricing !== undefined) {
					if (this.service.pricing.type === 'instant') {
						interval = this.$t('components.paymentplan.intervals.instant')
					} else if (this.service.pricing.type === 'recurring') {
						switch (this.service.pricing.interval) {
							case '1mo':
								interval = this.$t('components.paymentplan.intervals.monthly')
								break
							case '3mo':
								interval = this.$t('components.paymentplan.intervals.quarterly')
								break
							case '6mo':
								interval = this.$t('components.paymentplan.intervals.biannually')
								break
							case '1y':
								interval = this.$t('components.paymentplan.intervals.annually')
								break
						}
					}
				}

				return interval
			},

			cardDigits () {
        let digits

        if (this.service && this.service.nets_details !== null && this.service.nets_details.payment_details) {
          digits = this.service.nets_details.payment_details.maskedPan.slice(-4)
        } else {
          digits = false
        }

        return digits
			},

			getCardIcon () {
				let cardBrand
				let icon

        if (this.service.nets_details !== null && this.service.nets_details.payment_details) {
          cardBrand = this.service.nets_details.payment_details.paymentMethod.toUpperCase()
        }

				switch (cardBrand) {
					case 'VISA':
						icon = '<i class="fa fa-cc-visa"/>'
						break
					case 'MASTERCARD':
						icon = '<i class="fa fa-cc-mastercard"/>'
						break
					default:
						icon = '<i class="fa fa-credit-card"/>'
						break
				}

				return icon + '*' + this.cardDigits
			},

      canBeCancelled () {
        if (this.service.status === 'active') {
          if (this.service.pricing.type === 'instant') {
            let canCancelInstant = true
            this.service.transactions.forEach((value, index) => {
              if (value.status === 'success' || value.status === 'pending') {
                canCancelInstant = false
              }
            })
            return canCancelInstant
          }
          return true
        }
        return false
      },
      canChangePaymentMethod () {
        if (this.service.nets_details !== null) {
          if (this.service.status === 'active' || this.service.status === 'delayed' || this.service.status === 'overdue') {
            return !!this.service.nets_details.subscription_id
          }
        }
      }
		},

		beforeDestroy () {
			this.$events.$off('refreshservice')
		}
	}
</script>

<style lang="scss" scoped>
	.service {
		position: relative;
		display: flex;
		flex-flow: row;
		width: 100%;
		padding: 1.2rem;
		border-radius: 15px;
		background: #ffffff;
		box-shadow: -5px 5px 12px 0 rgba(0, 0, 0, .05), 5px 5px 12px 0 rgba(0, 0, 0, .05);
		overflow: hidden;
		margin: .5rem 0;
		height: auto;
		min-height: 100px;
		border: 1px solid rgba(0,0,0,0);

		-webkit-transition: all 0.2s;
		-moz-transition: all 0.2s;
		-ms-transition: all 0.2s;
		-o-transition: all 0.2s;
		transition: all 0.2s;

		&:hover, &.open {
			box-shadow: -5px 5px 12px 0 rgba(0, 0, 0, .1), 5px 5px 12px 0 rgba(0, 0, 0, .1);
			cursor: pointer;
			border: 1px solid #00a9f7;
		}
		// &.open {
		// 	position: fixed;
		// 	top:0;
		// 	left: 0;
		// 	height: 100%;
		// 	width: 100%;
		// 	z-index: 500;
		// 	overflow-y: auto;
		// 	border-radius: 0;
		// 	margin: 0;
		// }

		.image {
			width: 15%;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 1.5em;
			border: 5px solid #ccc;
			border-radius: 50%;

			>i {
				display: flex;
				height: auto;
				width: auto;
				align-items: center;
				justify-content: center;
				margin: 0 auto .5rem;
				font-size: 50px;
			}
		}

		.product {
			width: 100%;

			.title {
        display: flex;
        flex-direction: column;
				padding: 0 0 1rem 0;
				position: relative;

				.meta {
					color: rgba(0, 0, 0, 0.3);
				}

				.name {
					display: flex;
					flex-flow: row;
					width: 75%;
					position: relative;
					overflow: hidden;

					.status {
						flex-shrink: 0;
						display: flex;
						align-items: center;
						justify-content: center;
					}

					span {
						position: relative;
						font-size: 1.2em;
						width: inherit;
						text-overflow: ellipsis;
						overflow: hidden;
						flex-shrink: 0;
						white-space: nowrap;
					}
				}

				.right {
					display: flex;
          margin-top: 20px;

          .absolute-button {
            position: absolute;
            right: 0;
            top: 0;
          }

          @media only screen and (max-width: 350px) {
            button {
              font-size: .75rem;
            }
            .absolute-button {
              position: relative;
            }
          }
				}
			}

			> .info {
				display: flex;
				padding: 1rem 0 0 0;
				flex-flow: row;
				align-items: flex-start;
				justify-content: space-between;

				.metatitle {
					font-size: 0.8em;
					color: rgba(0, 0, 0, 0.3);
				}

				.interval {
					display: flex;
					flex-flow: column;
					justify-content: flex-start;
					align-items: flex-start;
					font-size: 1.2em;
				}

				.payment {
					display: flex;
					flex-flow: column;
					justify-content: flex-start;
					align-items: flex-start;
					font-size: 1.2em;
				}

				.price {
					display: flex;
					flex-flow: column;
					align-items: flex-end;
					font-size: 1.2em;
				}
			}

			>.content {
				padding: 1rem;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/subscription/Service.vue